export const CDN_HOST = 'https://d2gx7utkb1zhe1.cloudfront.net/';

export const BP_MOBILE_CHAT = 992; // Also referenced in globals.scss

export const FAILURE_TIMEOUT_SECONDS = 5;
export const LS_HASSEENWORLDINTRO_KEY = 'ARISE_HASSEENWORLDINTRO';
export const LS_HASSEENSHOP_KEY = 'ARISE_HASSEENSHOP';
export const LS_NEWSMODAL_LAST_VERSION_SEEN_KEY = 'ARISE_NEWSMODAL_LAST_VERSION_SEEN';
export const FEED_MESSAGES_TO_LOAD = 20;
